import React, { useEffect } from "react";
import EarlyCareersImg from '../Images/EarlyCareers.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

const EarlyCareers = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={EarlyCareersImg} alt="Early Careers" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Early Careers</h1>
                </div>
            </div>
            <div className="p-4 md:p-16 max-w-[620px] mx-auto">
                <p className="text-base md:text-lg mb-8 tracking-wider text-gray-700 font-light">
                    Architetive Designs offers a variety of programmes for students, undergraduates and graduates to kickstart their careers. Our multidisciplinary teams offer a range of different work placements for people who are passionate about their work, with a focus on learning and development.
                </p>
                <div>
                    <p className="text-base md:text-lg mb-4 tracking-wider text-gray-700 font-light">
                        Our programmes help you build on skills such as:
                    </p>
                    <ul className="text-base md:text-lg mb-8 tracking-wider text-gray-700 font-light">
                        <li>- Communication</li>
                        <li>- Diplomacy</li>
                        <li>- Working with others</li>
                        <li>- Responding to change</li>
                    </ul>
                </div>
                <h1 className="text-xl mb-6 text-gray-500">Explore</h1>
                <div className="flex-col space-y-4 mb-8">
                    <div className="space-x-3">
                        <Link to='/careers/vacancies'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Vacancies</button>
                        </Link>
                        <Link to='/careers/early-careers'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Early Careers</button>
                        </Link>
                        <Link to='/careers/benefits'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Benefits</button>
                        </Link>
                    </div>
                    <div>
                        <Link to='/people/equity-diversity-and-inclusion'>
                            <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Equity, Diversity and Inclusion</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EarlyCareers;